"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.explicitRootTestId = exports.explicitOverlayTestId = exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _usehooksTs = require("usehooks-ts");
var _Flex = _interopRequireDefault(require("../Flex"));
var _Text = _interopRequireDefault(require("../Text"));
var _Explicit = _interopRequireWildcard(require("./Explicit.styles"));
var _Dialog = _interopRequireDefault(require("../../components/Dialog"));
var _RaisedButton = _interopRequireDefault(require("../../components/RaisedButton"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _splitCommonFromProps7 = _interopRequireDefault(require("../../utils/splitCommonFromProps"));
var _excluded = ["blurBackground", "blurLevel", "className", "children", "onConfirm", "show", "translation"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */ /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var explicitRootTestId = exports.explicitRootTestId = "icf-explicit-root";
var explicitOverlayTestId = exports.explicitOverlayTestId = "icf-explicit-overlay";
var threshold = 280;
var Explicit = function Explicit(props) {
  var _splitCommonFromProps = (0, _splitCommonFromProps7.default)(props, _Explicit.explicitCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    common = _splitCommonFromProps2[0],
    _splitCommonFromProps3 = _splitCommonFromProps2[1],
    _splitCommonFromProps4 = _splitCommonFromProps3.blurBackground,
    blurBackground = _splitCommonFromProps4 === void 0 ? "rgba(0, 0, 0, 0.3)" : _splitCommonFromProps4,
    _splitCommonFromProps5 = _splitCommonFromProps3.blurLevel,
    blurLevel = _splitCommonFromProps5 === void 0 ? 16 : _splitCommonFromProps5,
    className = _splitCommonFromProps3.className,
    children = _splitCommonFromProps3.children,
    _splitCommonFromProps6 = _splitCommonFromProps3.onConfirm,
    onConfirm = _splitCommonFromProps6 === void 0 ? function () {} : _splitCommonFromProps6,
    show = _splitCommonFromProps3.show,
    translation = _splitCommonFromProps3.translation,
    otherProps = _objectWithoutProperties(_splitCommonFromProps3, _excluded);
  var _useElementSize = (0, _usehooksTs.useElementSize)(),
    _useElementSize2 = _slicedToArray(_useElementSize, 2),
    ref = _useElementSize2[0],
    dimensions = _useElementSize2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDialogOpen = _useState2[0],
    setIsDialogOpen = _useState2[1];
  var classes = (0, _Explicit.default)(_Explicit.explicitVars.useVars(_objectSpread({
    blurBackground: blurBackground,
    blurLevel: "blur(".concat(blurLevel, "px)")
  }, common)));
  if (show) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
  }
  var onlyIcon = dimensions.width < threshold || dimensions.height < threshold;
  var content = onlyIcon ? /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: "visibilityOff",
    className: classes.onlyIcon
  }) : /*#__PURE__*/_react.default.createElement(_Flex.default, {
    alignItems: "center",
    className: classes.contentOverlay
  }, /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: "visibilityOff",
    className: classes.iconHeader
  }), /*#__PURE__*/_react.default.createElement(_Flex.default, {
    alignItems: "center",
    className: classes.textOverlay
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    variant: "heading_s",
    color: "textOnDark",
    textAlign: "center"
  }, translation.explicitTitle), /*#__PURE__*/_react.default.createElement(_Text.default, {
    variant: "body_m",
    color: "textOnDark",
    textAlign: "center"
  }, translation.explicitExplanation)), /*#__PURE__*/_react.default.createElement(_RaisedButton.default, {
    label: translation.explicitButton,
    onClick: onConfirm
  }));
  var handleDialog = function handleDialog(accept) {
    return function () {
      setIsDialogOpen(false);
      if (accept) {
        onConfirm();
      }
    };
  };
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", _extends({
    ref: ref,
    className: (0, _classnames.default)(classes.variables, classes.root, _defineProperty({}, classes.iconOverlay, onlyIcon), className),
    onClick: function onClick() {
      return onlyIcon ? setIsDialogOpen(true) : undefined;
    },
    "data-ta-locator": explicitRootTestId
  }, otherProps), children, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.overlay),
    "data-ta-locator": explicitOverlayTestId
  }, content)), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    confirmLabel: translation.dialogAgreeButton,
    confirmOnClick: handleDialog(true),
    content: translation.dialogExplanation,
    denyLabel: translation.dialogDenyButton,
    denyOnClick: handleDialog(false),
    open: isDialogOpen,
    title: translation.dialogTitle,
    width: 320
  }));
};
Explicit.displayName = "Explicit";
var Storybook = exports.Storybook = Explicit;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/overlay-explicit--docs
 */
var exportedComponent = (0, _defaultProps.default)(Explicit);
exportedComponent.displayName = "Explicit";
var _default = exports.default = exportedComponent;